import React, { useState } from "react";
import api from "../lib/api";
import CargoForm from "../components/CargoForm";
import PickupEntryList, { pickupToCargo } from "../components/PickupEntryList";
import { toast } from "sonner";

export default function CargoEntry() {
  const [resetKey, setResetKey] = useState(0);
  const [pick, setPick] = useState(null);
  const choose = async (r) => {
    if (r.kargo_id) {
      try { const { data } = await api.get(`/cargo/${r.kargo_id}`); setPick({ id: r.id, cargoId: r.kargo_id, initial: data.data }); }
      catch { toast.error("KARGO BULUNAMADI"); return; }
    } else setPick({ id: r.id, initial: pickupToCargo(r) });
    setResetKey((k) => k + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const saved = () => { if (pick) toast.success("BEKLEYEN FATURALARA DÜŞTÜ"); setPick(null); setResetKey((k) => k + 1); };
  return (
    <div data-testid="cargo-entry-page" className="mw-fade-up space-y-2">
      <div className="flex items-center gap-3">
        <h1 className="font-head text-xl font-bold tracking-tight text-white">KARGO GİRİŞİ</h1>
        <span className="text-[11px] text-slate-500">KAYITLI MÜŞTERİYİ YAZIP SEÇİN · KAYITSIZSA ⚡ İLE KAŞE / GÖRSEL / YAZIDAN EKLEYİN · ÜST ALANLARI SÜRÜKLEYİP SIRALAYIN</span>
        {pick && <span data-testid="cargo-entry-from-pickup" className="rounded bg-orange-900/60 px-2 py-0.5 text-[11px] font-bold text-orange-200">ALIM #{pick.id}{pick.cargoId ? ` · KARGO #${pick.cargoId} DÜZELTİLİYOR` : " · OPERASYONDAN AKTARILIYOR"}
          <button data-testid="cargo-entry-cancel-pickup" onClick={() => { setPick(null); setResetKey((k) => k + 1); }} className="ml-2 text-orange-100 underline">VAZGEÇ</button></span>}
      </div>
      <CargoForm key={resetKey} initial={pick?.initial} cargoId={pick?.cargoId} onSaved={saved} submitLabel={pick ? "KAYDET → BEKLEYEN FATURALARA DÜŞÜR" : undefined} />
      <PickupEntryList reloadKey={resetKey} activeId={pick?.id} onPick={choose} />
    </div>
  );
}
